import React, { useCallback, useMemo } from 'react';
import { BetStatus, isMobile } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { AmountSection } from '../../components/amountSection';
import { Cashout } from '../../components/cashout';
import { DealSection } from '../../components/dealSection';
import { doBetStore } from '../../store/doBetStore';
import { GambleSection } from '../../components/gambleSection';
import { cardsStore } from '../../store/cardsStore';
import { UNKNOWN_CARD_TYPE } from '../../enums/cardTypes';
import { gameStore } from '../../store/gameStore';

export const BetActionWrapper = observer(() => {
  const { isShowGamble } = doBetStore;
  const { tableCards } = cardsStore;
  const { roundStatus } = gameStore;

  const isDisableGambleAndCashout = useMemo(() => {
    if (isShowGamble) {
      return tableCards.some((item) => item.card === UNKNOWN_CARD_TYPE);
    }
    return false;
  }, [isShowGamble, tableCards]);

  const GambleOrAmountSection = useCallback(() => {
    return (
      <div className='main-button-wrapper'>
        <div className='buttons-top-container'>
          {isShowGamble && roundStatus === BetStatus.Pending ? (
            <GambleSection isDisable={isDisableGambleAndCashout} />
          ) : (
            <AmountSection />
          )}
          <Cashout isDisable={isDisableGambleAndCashout} />
        </div>
        {(!isShowGamble || roundStatus === BetStatus.Lose) && <DealSection />}
      </div>
    );
  }, [isDisableGambleAndCashout, isShowGamble, roundStatus]);

  if (isMobile()) {
    return (
      <div className='tp-g-mobile-bottom'>
        <div className='tp-big-btn-wrp'>
          <GambleOrAmountSection />
        </div>
      </div>
    );
  }

  return <GambleOrAmountSection />;
});
